import { usePathname, useSearchParams } from "next/navigation";
import Image from 'next/image';
import { BLUR_DATAURL } from "../constants";
import { Suspense, useEffect, useLayoutEffect, useState } from "react";
import BackButton from "./back_button";
import IndexButton from "./index_button";
import { GetById } from "../utils/getById";
import { GetIdTag } from "../interface/type";
import { getOffsetsById, getScrollInfo, scrollIntoViewById } from "../utils/scrollIntoTheView";

export default function Navigation() {
  const currentPage = usePathname();
  const notNavigatorUrls = ["/"];
  const searchParams = useSearchParams();
  const isApp = searchParams.get("isApp") || "";
  const [byIds, setByIds] = useState<Array<GetIdTag>>([]);

  // useLayoutEffect(() => {
  //   if (typeof window !== "undefined") {
  //     // ✅ 페이지 렌더 완료 후 Flutter에게 알림
  //     setTimeout(() => {
  //       (window as any).flutter_inappwebview?.callHandler('renderComplete');
  //     }, 1000);
  //   }
  // }, []);

  useEffect(() => {
    const ids = GetById();
    setByIds([...ids]);
    // window.appToWeb = (id: string) => ScrollIntoTheView(id);

    if (typeof window !== "undefined") {
      (window as any).getScrollInfo = getScrollInfo;
      (window as any).getOffsetsById = getOffsetsById;
      (window as any).appToWeb = scrollIntoViewById;
    }

  }, [currentPage]);

  return <>
    {isApp === "true" ? <></> : <div className="sticky z-10 top-0 p-3 flex items-center justify-between bg-white border-b border-neutral-300 dark:border-neutral-700">
      {notNavigatorUrls.includes(currentPage) ?
        <div>
          <Image
            src="/images/logo.png"
            alt="투어캐스트"
            width="0"
            height="0"
            sizes="100vw"
            className="w-36 h-auto"
            loading="lazy"
            placeholder="blur"
            blurDataURL={BLUR_DATAURL}
          />
        </div>
        :
        <Suspense>
          <BackButton />
        </Suspense>
      }

      <div className="flex items-center	">
        <Suspense>
          <IndexButton indexs={byIds} />
        </Suspense>

        {/* 로그인 버튼 */}
        {/* {session?.user != null ? <button
                    className="focus:outline-none w-16 h-10 rounded-md flex items-center justify-center hover:bg-neutral-100"
                  >
                    로그아웃
                  </button> : <button
                    className="focus:outline-none w-16 h-10 rounded-md flex items-center justify-center hover:bg-neutral-100"
                  >
                    로그인
                  </button>} */}
      </div>
    </div>}
  </>;
}
